<template>
  <div class="prakerja-search-page min-h-screen">
    <BlNavBarSearchMv
      :value="getKeywords"
      has-back-button
      :auto-focus="isKeyboardAutoFocus"
      placeholder="Cari kelas atau penyedia"
      class="w-full bg-white border-bottom-gray fixed top-0 z-50"
      style="max-width: 480px; margin: 0 auto"
      @handleBackButtonClick="handleBackButton"
      @input="handleSearch"
    />

    <PrakerjaFilterSortTab
      data-testid="search-page-filter-tab"
      @leftTabClick="$router.push({name: 'search-location'})"
      @middleTabClick="$router.push({name: 'search-filter'})"
      @rightTabClick="$router.push({name: 'search-sort'})"
    />

    <div v-if="isAppLoading && !getCourses.length" class="prakerja-search-page__shimmer mb-12 mh-8 w-full">
      <PrakerjaCardShimmer :count="4" class="pt-12" />
    </div>

    <template v-else>
      <div v-if="getCourses.length" class="grid grid-cols-2 gap-2 mh-16 mt-12 qa-search-result">
        <BlFlexItemAv
          v-for="(course, index) in getCourses"
          :key="index"
          grow="1"
          basis="1"
          class="prakerja-card-wrapper qa-prakerja-course"
        >
          <PrakerjaCard :course="course" :course-type="course.course_type" class="ut-normal-course-card" normal-course />
        </BlFlexItemAv>
      </div>

      <BlEmptyStateMv
        v-else-if="!getPagination.total"
        type="full"
        title="Kelas yang kamu cari tidak ada"
        description="Kamu bisa coba pakai kata pencarian lain."
      />
    </template>

    <div
      v-infinite-scroll="fetchMoreCourses"
      :infinite-scroll-disabled="getIsAllCoursesLoaded"
      :infinite-scroll-distance="500"
      class="w-full"
      style="height: 20px"
    ></div>

    <router-view />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import {BlFlexItemAv, BlNavBarSearchMv} from '@bukalapak/bazaar-mweb-latest';

import PrakerjaCardShimmer from '../components/PrakerjaCardShimmer/PrakerjaCardShimmer.vue';
import PrakerjaFilterSortTab from '../components/PrakerjaSearchPage/PrakerjaFilterSortTab.vue';

import infiniteScroll from 'vue-infinite-scroll';
import PrakerjaCard from '../components/PrakerjaCard/PrakerjaCard.vue';

export default {
  name: 'PrakerjaSearchPage',
  directives: {infiniteScroll},
  components: {
    PrakerjaCard,
    BlFlexItemAv,
    PrakerjaCardShimmer,
    BlNavBarSearchMv,
    BlEmptyStateMv: () => import('@bukalapak/bazaar-mweb-latest/dist/components/BlEmptyStateMv'),
    PrakerjaFilterSortTab,
  },
  data: () => ({
    sortBy: 'name',
    isDisplaySortSheet: false,
    searchTimeout: null,
  }),
  computed: {
    ...mapGetters(['isAppLoading', 'getPreviousPage']),
    ...mapGetters('courses', [
      'getCourses',
      'getPagination',
      'getIsAllCoursesLoaded',
      'getKeywords',
      'getSortCoursesBy',
      'getSortCourseOptions',
    ]),
    isKeyboardAutoFocus() {
      return this.$route?.name === 'search';
    },
  },
  created() {
    this.$store.commit('courses/resetCourses');

    if (this.getPreviousPage?.name === 'landing') {
      this.$store.commit('categories/setSelectedCategory', 'all');
    }
  },
  mounted() {
    if (this.$route.query.keyword) {
      const lowercasedKeyword = this.$route.query.keyword.toLowerCase();
      this.$store.commit('courses/setCoursesFilter', {keywords: lowercasedKeyword});
      this.$router.replace({name: 'search', query: {...this.$route.query, keyword: lowercasedKeyword}});
    } else {
      this.scrollToTop();
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    handleSearch(value) {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = null;
      }

      this.searchTimeout = setTimeout(() => {
        const lowercasedKeyword = value.toLowerCase();

        this.$store.commit('courses/setCoursesFilter', {keywords: lowercasedKeyword});
        this.$router.replace({name: 'search', query: {...this.$route.query, keyword: lowercasedKeyword}});

        this.$store.commit('courses/resetCourses');
        this.$store.dispatch('courses/fetchCourses').then(() => {
          this.trackPrakerjaSearch();
        });

        this.scrollToTop();
      }, 500);
    },
    fetchMoreCourses() {
      this.$store.dispatch('courses/fetchCourses');
    },
    handleBackButton() {
      this.$router.push({name: 'landing', query: {...this.$route.query, keyword: undefined}});
    },
    trackPrakerjaSearch() {
      const payload = {
        evn: 'vp_prakerja_search',
        source: this.$root.source,
        referrer: this.$root.referrer,
        ui: window.USER.id36,
        session_id: this.$root.mixinSessionId,
        keyword: this.$route.query.keyword,
        any_result: !!this.getCourses.length,
      };
      this.$tracker.event(payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.prakerja-search-page {
  padding-top: 56px;
  &::v-deep {
    .bl-empty-state {
      img {
        margin: 0 auto;
      }
      height: calc(100vh - 56px);
    }
  }
}
</style>
